export default __webpack_public_path__ + "static/media/turismoComunitario.f58a936e.jpg";